/**
 * Created by dev on 10/13/15.
 */
'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var Review = require('bunsen/models/ecomm/Review');
var Reviews = module.exports = SoaCollection.extend();

module.exports = SoaCollection.extend({
    model: Review,
    getShippingRequest: function () {
        return this.findWhere({'type': Review.TYPE_SHIPPING_REQUEST});
    },
    removeShippingRequestReview: function () {
        this.remove(this.getShippingRequest());
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/Reviews.js
// module id = 165
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56